import { useState } from 'react';
import { Button } from '@/app/components/ui/button';
import { Card, CardContent } from '@/app/components/ui/card';
import { Textarea } from '@/app/components/ui/textarea';
import { useProjectNotes, useCreateProjectNote } from '@/hooks/use-projects';

export function NotesTab({ projectId }: { projectId: number }) {
  const { data: notes } = useProjectNotes(projectId);
  const createNote = useCreateProjectNote();
  const [newNote, setNewNote] = useState('');

  const handleAddNote = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!newNote.trim()) return;
    await createNote.mutateAsync({ projectId, data: { content: newNote } });
    setNewNote('');
  };

  return (
    <div className="space-y-4">
      <form onSubmit={handleAddNote} className="flex gap-2">
        <Textarea
          placeholder="Add a note..."
          value={newNote}
          onChange={(e) => setNewNote(e.target.value)}
          rows={2}
          className="flex-1"
          required
        />
        <Button type="submit" disabled={createNote.isPending}>
          Post
        </Button>
      </form>

      <div className="space-y-3">
        {notes?.map((note) => (
          <Card key={note.id}>
            <CardContent className="p-4">
              <div className="flex items-start justify-between mb-2">
                <span className="text-sm font-medium text-gray-900">
                  {note.author_username}
                </span>
                <span className="text-xs text-gray-500">{note.created_at}</span>
              </div>
              <p className="text-gray-600 whitespace-pre-wrap">{note.content}</p>
            </CardContent>
          </Card>
        ))}
        {(!notes || notes.length === 0) && (
          <p className="text-gray-500 text-center py-8">No notes yet</p>
        )}
      </div>
    </div>
  );
}
